import { SavedReport } from "Services/Api/Reports/Types";
import { TFunction } from "i18next";
import ActionsButton from "./ActionsButton";
import { STANDARD_REPORT_TYPE_MAP } from "Pages/Reports/Standard/Standard.constants";
import { OptionalValue, Tooltip } from "Components";
import { REPORT_FREQUENCIES_MAP } from "Pages/Report/EditReport/EditReport.constants";

const MobileView = ({ records, t } : { records: SavedReport[], t: TFunction }) => {
    return <div className="records-section">
        {records.map(record => {
            const [firstEmail, ...rest] = (record?.emailsList || []);
            const restEmailCount = (rest?.length || 0);
            return <div key={record.id} className="record">
            <div className="row">
                <span className="title">{record.name}</span>
                <ActionsButton report={record} isMobile={true} />
            </div>
            <div className="row">
                <span className="label">{t('reports.tabs.saved.columns.reportType')}</span>
                <span className="title">{STANDARD_REPORT_TYPE_MAP[record.reportType]?.label(t) ?? ''}</span>
            </div>
            <div className="row">
                <span className="label">{t('reports.tabs.saved.columns.recurrenceType')}</span>
                <span className="title">{<OptionalValue>
					{record.recurrenceType && t(REPORT_FREQUENCIES_MAP[record.recurrenceType]?.label)}
				</OptionalValue>}</span>
            </div>
            <div className="row">
                <span className="label">{t('reports.tabs.saved.columns.emailsList')}</span>
                <span className="title">
                    <Tooltip
                        trigger={"hover"}
                        placement="top"
                        enabled={!!restEmailCount}
                        title={record?.emailsList?.join(", ")}
                        overlayClassName="info-tooltip">
                        <div>{firstEmail ? restEmailCount ? restEmailCount + 1 : firstEmail : "-"}</div>
                    </Tooltip>
                </span>
            </div>
        </div>
        })}
    </div>
}

export default MobileView;